import { Button } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router-dom'

import { GapBox } from 'components/Box'
import FilterRoot, { FilterValue } from 'components/Filter'
import { Link } from 'components/Link'
import Paper from 'components/Paper'
import { TableHeader } from 'components/Table'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useAbility } from 'providers/casl'
import { ROUTES } from 'routes'
import AbTestsTable from './components/AbTestsTable'
import { AB_TESTS_KNOWLEDGE_BASE_URL } from './constants'

export const AbTestsList = (): JSX.Element => {
  const ability = useAbility()
  const { workspaceId } = useWorkspaceParam()
  const { t } = useTranslation(['features/abTests', 'common'])
  const [filters, setFilters] = useState<FilterValue[]>([])

  const Filter = (
    <FilterRoot
      id='ab-tests-filter'
      onChange={setFilters}
      placeholder={t('list.filter')}
      values={filters}
    />
  )

  const canCreate: boolean = ability.can('create', 'AbTests')

  const AddNew = (): JSX.Element => (
    <Link to={generatePath(ROUTES.AB_TESTS.ADD, { workspaceId })}>
      <Button
        data-cy='ab-tests-button-add'
        variant='contained'
      >
        {t('list.add')}
      </Button>
    </Link>
  )

  return (
    <Paper>
      <TableHeader
        actions={canCreate ? <AddNew /> : undefined}
        description={t('list.description')}
        descriptionEndAdornment={
          <Link
            newTab
            to={AB_TESTS_KNOWLEDGE_BASE_URL}
          >
            {t('common:learnMore')}
          </Link>
        }
        filter={Filter}
        title={t('list.title')}
      />

      <GapBox />

      <AbTestsTable filters={filters} />
    </Paper>
  )
}
